import { render, staticRenderFns } from "./comboTable.vue?vue&type=template&id=71e6c990"
import script from "./comboTable.vue?vue&type=script&lang=js"
export * from "./comboTable.vue?vue&type=script&lang=js"
import style0 from "./comboTable.vue?vue&type=style&index=0&id=71e6c990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports